<script>
  import { teamStore } from "../../../../../api-stores/license-store";
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";
  import { selectedLicenseKindsStore } from "../stores";

  let licenses = $derived.by(() => ($teamStore || {}).licenses || []);

  let items = $derived.by(() =>
    (licenses || [])
      .filter((m) => !["viewer", "alias", "dataRefresh"].includes(m.kind))
      .map((m) => ({
        id: m.kind,
        label: m.title,
        title: m.title,
      }))
  );
</script>

<MultiSelectDropdown
  label="Licenses"
  showFilter={false}
  {items}
  bind:selectedItems={$selectedLicenseKindsStore}
  placeholder="Select licenses"
  showDescription={true}
/>
